
export const selectSalesSessions = (s) => s?.salesSessions ?? {};

export const selectSessionsOrder   = (s) => selectSalesSessions(s).order   ?? [];
export const selectSessionsById    = (s) => selectSalesSessions(s).byId    ?? {};
export const selectActiveSessionId = (s) => selectSalesSessions(s).activeId ?? null;

export const hasAnySession = (state) => {
  const order = selectSessionsOrder(state);
  if (Array.isArray(order) && order.length > 0) return true;
  const byId = selectSessionsById(state);
  return Object.keys(byId).length > 0;
};
